export default __webpack_public_path__ + "static/media/whatsapp.10034b74.svg";